<script>
  import { _ } from 'svelte-i18n'
  import UAParser from 'ua-parser-js'
  import Button from '../elements/Button.svelte'

  const uaParser = new UAParser()
  const browser = uaParser.getBrowser()
  const url = browser.name === 'Edge' ? 'https://microsoftedge.microsoft.com/addons/detail/wordmarkit-extension/jnpiemcccmekekaadgbcmchlcnmobged' : 'https://chrome.google.com/webstore/detail/wordmarkit-extension/plafaneablgcojpbaeefkmnheilloopl'
  export let reload_required = false;

  function sendEventToAnalytics(platform) {
    if (typeof window.gtag == "undefined") return
    gtag('event', 'begin_install', {
      'event_category': 'extension'
    });
  }
</script>

<div class="button-wrapper">
  {#if browser.name === 'Safari' || browser.name === 'Firefox'}
    <Button 
      kind={'accent'}
      href={'https://www.google.com/chrome/'}
      target={'_blank'}>
       ↗︎ {$_('buttons.download')} Google Chrome
    </Button>
    <Button 
      kind={'accent'}
      href={'https://www.microsoft.com/en-us/edge'}
      target={'_blank'}>
       ↗︎ {$_('buttons.download')} Microsoft Edge
    </Button>
  {:else}
    <Button 
      on:click={() => { reload_required = true; sendEventToAnalytics()}}
      kind={'accent'}
      href={url}
      target={'_blank'}>
      {$_('extension.getButton')}
    </Button>
    <small>100.000+ installs on Chrome Web Store</small>
  {/if}
</div>

<style>
  .button-wrapper {
    display: flex;
    flex-direction: row;
    margin: 4rem 0;
  }
  .button-wrapper small {
    width: auto;
    margin-left: -1rem;
    font-size: 1.6rem;
    font-variant: lining-nums;
    font-family: var(--PensumSans);
    line-height: 4rem;
    color: var(--c-text);
  }
  .button-wrapper :global(a) {
    margin-right: 2rem;
  }
</style>